"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _constants = require("./constants");

var _actions = require("./actions");

var _AppActions = require("../actions/AppActions");

var _Branding = _interopRequireDefault(require("./Branding"));

var _Address = _interopRequireDefault(require("./Address"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  companyName: null,
  companyAddress: new _Address.default(),
  data: new _Branding.default(),
  staged: new _Branding.default()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchCompanyInfoActionTypes.SUCCESS, function (state, action) {
  if (action.payload.data.status === 404) {
    return state;
  }

  var _action$payload$data = action.payload.data,
      companyName = _action$payload$data.companyName,
      physicalAddress = _action$payload$data.physicalAddress;
  return state.merge({
    companyName: companyName,
    companyAddress: new _Address.default(physicalAddress)
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions.FetchBrandingActionTypes.SUCCESS, _actions.SaveBrandingActionTypes.SUCCESS), function (state, action) {
  return state.merge({
    data: _Branding.default.fromAPI(action.payload.data),
    staged: _Branding.default.fromAPI(action.payload.data)
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_COMPANY_LOGO_URL, function (state, action) {
  return state.setIn(['staged', _constants.COMPANY_LOGO_URL], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_COMPANY_LOGO_ALT_TEXT, function (state, action) {
  return state.setIn(['staged', _constants.COMPANY_LOGO_ALT_TEXT], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_COMPANY_AVATAR, function (state, action) {
  return state.setIn(['staged', _constants.COMPANY_AVATAR], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_PRIMARY_COLOR, function (state, action) {
  return state.setIn(['staged', _constants.PRIMARY_COLOR], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_SECONDARY_COLOR, function (state, action) {
  return state.setIn(['staged', _constants.SECONDARY_COLOR], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_ACCENT_COLOR, function (state, action) {
  return state.setIn(['staged', _constants.ACCENT_COLOR], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_ACCENT2_COLOR, function (state, action) {
  return state.setIn(['staged', _constants.ACCENT2_COLOR], action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.BrandingActionTypes.STAGE_BRANDING_INFO, function (state, action) {
  return state.setIn(['staged', action.key], action.payload);
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions.BrandingActionTypes.RESET_STAGED_SETTINGS, _AppActions.AppActionTypes.RESET_STAGED_CHANGES), function (state) {
  return state.set('staged', new _Branding.default(state.get('data')));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;